import { Box, Typography } from '@mui/material';
import { numberFormat } from '../../Utilis/numberFormater';

const TaxSavings = ({
  estimatedTaxSaving,
  lifeTimeImpact,
}: {
  estimatedTaxSaving: number | undefined;
  lifeTimeImpact: number | undefined;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',

        '@media(max-width:768px)': {
          flexDirection: 'column',
          maxWidth: '100%',
          gap: 10
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'center', padding: '0 40px' }}>
        <Typography
          color={'#202A2D'}
          fontWeight={'600'}
          fontSize={'14px'}
          lineHeight={'20px'}
          whiteSpace={'nowrap'}
        >
          Estimated Tax Savings
        </Typography>
        <Typography
          color={'#202A2D'}
          fontWeight={'400'}
          fontSize={'14px'}
          lineHeight={'20px'}
        >
          Current Tax Year
        </Typography>
        <Typography
          color={'#655C68'}
          fontWeight={'600'}
          fontSize={'48px'}
          lineHeight={'38px'}
          mt={'26px'}
        >
          ${numberFormat(estimatedTaxSaving)}
        </Typography>
      </Box>
      
        <Box
          sx={{
            height: '200px',
            background:
              ' linear-gradient(180deg, #E3DDE6 1.04%, #ACC7DC 27.6%, #BCCDE4 86.46%, #E3DDE6 98.44%)',
            width: '3px',

            '@media(max-width:768px)': {
              display: 'none',
            },
          }}
        />
      

      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'center', padding: '0 40px' }}>
        <Typography
          color={'#202A2D'}
          fontWeight={'600'}
          fontSize={'14px'}
          lineHeight={'20px'}
          whiteSpace={'nowrap'}
        >
          Lifetime Impact
        </Typography>
        <Typography
          visibility={'hidden'}
          lineHeight={'20px'}
          fontWeight={'400'}
          fontSize={'14px'}
        >
          Current Tax Year
        </Typography>
        <Typography
          color={'#655C68'}
          fontWeight={'600'}
          fontSize={'48px'}
          lineHeight={'38px'}
          mt={'26px'}
        >
          ${numberFormat(lifeTimeImpact)}
        </Typography>
      </Box>

      <Box
        sx={{
          width: '3px',
          height: '200px',
          background:
            ' linear-gradient(180deg, #E3DDE6 1.04%, #ACC7DC 27.6%, #BCCDE4 86.46%, #E3DDE6 98.44%)',
          '@media(max-width:1372px)': {
            display: 'none',
          },
        }}
      />
    </Box>
  );
};

export default TaxSavings;
